// @flow
import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const deleteMutation = graphql`
	mutation ConfigurableBlockDeleteMutation($input: ConfigurableBlockDeleteInput!) {
		ConfigurableBlockDelete(input: $input) {
			error
		}
	}
`;
export function commit(environment: Environment, params: any, callback: (error: ?Error) => void) {
	console.log(params);
	commitMutation(environment, {
		mutation: deleteMutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const { error, id } = response.ConfigurableBlockDelete;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, id);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/components/configurable-blocks/mutations/ConfigurableBlockDelete.js